/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientMasterAllergyTypename = "PatientMasterAllergy" as const;

/**
 *
 * @export
 * @interface PatientMasterAllergy
 */
export interface PatientMasterAllergy {
  /**
   *
   * @type {string}
   * @memberof PatientMasterAllergy
   */
  masterCode: string;
  /**
   *
   * @type {string}
   * @memberof PatientMasterAllergy
   */
  masterGroup?: string;
  /**
   *
   * @type {string}
   * @memberof PatientMasterAllergy
   */
  masterName?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientMasterAllergy
   */
  readonly __typename?: string;
}

export function PatientMasterAllergyFromJSON(json: any): PatientMasterAllergy {
  return PatientMasterAllergyFromJSONTyped(json, false);
}

export function PatientMasterAllergyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientMasterAllergy {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientMasterAllergyTypename,

    masterCode: json["master_code"],
    masterGroup: !exists(json, "master_group") ? undefined : json["master_group"],
    masterName: !exists(json, "master_name") ? undefined : json["master_name"],
  };
}

export function PatientMasterAllergyToJSON(object?: PatientMasterAllergy | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    master_code: value.masterCode,
    master_group: value.masterGroup,
    master_name: value.masterName,
  };
}
